import { Component,
  Input,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter } from '@angular/core';

import { DropdownMenuOption } from 'app/models/dropdown-menu-option';
import { File } from 'app/models/file';
import { Storyboard } from 'app/models/storyboard';
import { FileSizePipe } from 'app/shared/pipes/file-size.pipe';
import { FileType } from 'app/models/file-type.enum';
import { StoryboardService } from 'app/services/storyboard.service';

@Component({
  selector: 'app-storyboard-header',
  templateUrl: './storyboard-header.component.html',
  styleUrls: ['./storyboard-header.component.scss']
})
export class StoryboardHeaderComponent implements OnInit, OnChanges {
  @Input() storyboard: Storyboard;
  @Output() change: EventEmitter<File> = new EventEmitter();
  fileSelected: number;
  options: Array<DropdownMenuOption>;
  thumbnailSetConfirmed = false;

  constructor(private fileSizePipe: FileSizePipe, private storyboardService: StoryboardService) {}

  get currentFileIsVideo(): boolean {
    if (!this.storyboard?.files?.length) return false;
    const file = this.storyboard.files[this.fileSelected];
    return file?.contentType === FileType.Video;
  }

  setAsThumbnail(): void {
    if (!this.storyboard?.files?.length) return;
    const file = this.storyboard.files[this.fileSelected];
    if (file) {
      this.storyboard.thumbnailFileId = file.id;
      this.storyboardService.update(this.storyboard).subscribe();
      this.thumbnailSetConfirmed = true;
      setTimeout(() => this.thumbnailSetConfirmed = false, 2500);
    }
  }

  changeFile(direction): void {
    switch (direction) {
      case 'previous':
        if (this.fileSelected > 0) {
          --this.fileSelected;
        }
        break;
      case 'next':
        if (this.fileSelected < this.storyboard.files.length - 1) {
          ++this.fileSelected;
        }
        break;
    }

    this.change.emit(this.storyboard.files[this.fileSelected]);
  }

  ngOnChanges(allChanges: SimpleChanges) {
    if (allChanges.storyboard.currentValue) {
       this.options = [
        new DropdownMenuOption('1',
        'Download Set ('
          + this.fileSizePipe.transform(allChanges.storyboard.currentValue.size, 'MB') + ')'),
        new DropdownMenuOption('2', 'Share Set'),
        new DropdownMenuOption('3', 'Ask Question About Set')
      ];
    }
  }

  ngOnInit() {
    this.fileSelected = 0;
  }
}
